@if (loading()) {
  @defer (on timer(1s)) {
    <onyx-spinner color="blue" [size]="48"></onyx-spinner>
  }
} @else if (error()) {
  <onyx-loading-error
    [message]="message()"
    [(error)]="error"
  ></onyx-loading-error>
}
